import styled from "styled-components/macro";
import { Text } from "@gcs/design-system/react";

export const Container = styled.section(({ theme }) => ({
  padding: "48px 20px 200px 20px",
  flexDirection: "column",
  display: "block",

  [theme.breakpoint.md()]: {
    padding: "48px 100px 200px 100px",
  },

  [theme.breakpoint.lg()]: {
    padding: "48px 200px 200px 100px",
  },

  [theme.breakpoint.xl()]: {
    padding: "48px 300px 200px 100px",
  },

  "@media (min-width: 1480px)": {
    padding: "48px calc((100% - 860px)/2) 200px calc((100% - 1260px)/2)",
  },
}));

export const Title = styled(Text)({
  marginBottom: "20px",
});

export const Paragraph = styled(Text)({
  marginBottom: "20px",
});
